'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/dom-helpers/util/inDOM.js
// module id = 86
// module chunks = 168707334958949